import { render, staticRenderFns } from "./envioveraz.vue?vue&type=template&id=07f75ead"
import script from "./envioveraz.vue?vue&type=script&lang=js"
export * from "./envioveraz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports